import React from 'react';
import { Footer, Navbar } from '../components';
import PCIPage from '../components/PCIPage';
import Seo from '../components/Seo';


function PCI() {
    return (
        <div>
            <Seo
                title="PCI DSS Compliance"
                description="WayaQuick is PCI DSS Level 1 certified and holds a PSSP licence from the Central Bank of Nigeria. See how we keep your payments secure."
            />
            <Navbar />
            <PCIPage/>
            <Footer />
        </div>
    )
}

export default PCI
